<template>
  <div class="mb-12 mt-24 md:mt-9">
    <div class="flex justify-between">
      <h1 class="mb-3">Deine Aufträge</h1>

      <div data-testId="refreshOrdersButton" @click="refreshOrderList">
        <em
          class="mdi mdi-24px mdi-refresh cursor-pointer"
          :class="{ 'rotate-animation': isLoading }"
        ></em>
      </div>
    </div>
    <div v-if="lastUpdatedTimestamp" data-testId="orderListLastUpdated">
      Zuletzt aktualisiert am : {{ lastUpdatedTimestamp }}
    </div>
    <div v-if="Object.keys(groupedOpenOrders).length > 0">
      <div v-for="(orders, index) in groupedOpenOrders" :key="index">
        <h4>{{ index }}</h4>
        <div
          v-for="order in orders"
          :key="order.id"
          :data-testid="`orderCard_open_${order.orderId}`"
        >
          <OrderCard
            :is-selected="order.id === selectedOrder?.id"
            :order="order"
            @click="$emit('update:selectedOrder', order)"
          />
        </div>
      </div>
    </div>
    <h5 v-else class="rounded-xl bg-light-1 px-7 py-10 dark:bg-dark-1">
      Wir konnten keine offenen Aufträge für dich finden.<br />Bitte kontaktiere
      deinen Disponent:in.
    </h5>
    <div v-if="closedOrders.length > 0">
      <h3
        data-testid="closedOrdersSpoiler"
        :data-open="showClosedOrders"
        @click="toggleClosedOrders"
      >
        <em
          :class="{
            'mdi mdi-chevron-up': showClosedOrders,
            'mdi mdi-chevron-down': !showClosedOrders,
          }"
        />
        Abgeschlossene Aufträge
      </h3>
      <div v-if="showClosedOrders">
        <div
          v-for="order in closedOrders"
          :key="order.id"
          :data-testid="`orderCard_closed_${order.orderId}`"
        >
          <OrderCard
            :is-selected="order.id === selectedOrder?.id"
            :order="order"
            @click="$emit('update:selectedOrder', order)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import OrderCard from '@/components/OrderManagement/OrderCard.vue';
import { Order } from '@/models/Order';

const emits = defineEmits(['refreshOrders', 'update:selectedOrder']);
const selectedOrder = defineModel<Order | null>('selectedOrder', { required: true });

const props = defineProps<{
  isLoading: boolean;
  lastUpdatedTimestamp: string;
  groupedOpenOrders: Record<string, Order>;
  closedOrders: Order[];
}>();

const refreshOrderList = () => {
  emits('refreshOrders');
};

const showClosedOrders = ref(false);
const toggleClosedOrders = () => {
  showClosedOrders.value = !showClosedOrders.value;
};
</script>

<style scoped>
.rotate-animation:before {
  animation: rotate 1s infinite linear;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
